import { deleteTenderApplicationDocumentDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const deleteTenderApplicationDocumentCallable = getCallable(
  deleteTenderApplicationDocumentDefinition,
);
